/* eslint-disable import/no-unresolved */
import { stripHtml } from 'string-strip-html';

export const stripHtmlContent = (content: string) =>
  stripHtml(content).result || '';
